import script from "./capacityScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./capacityScreen.vue?vue&type=script&setup=true&lang=js"

import "./capacityScreen.vue?vue&type=style&index=0&id=81023bee&lang=scss&scoped=true"

import exportComponent from "F:\\tubida\\tbd_screen_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81023bee"]])

export default __exports__